import { render, staticRenderFns } from "./TimeBlock.vue?vue&type=template&id=ed613346&"
import script from "./TimeBlock.vue?vue&type=script&lang=ts&"
export * from "./TimeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TimeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VChip,VScaleTransition})
